
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type FavoriteItem = {
  featureId: string; 
  pinnedAt: number;
};

interface SidebarPreferencesState {
  isCompactMode: boolean;
  favorites: FavoriteItem[];
  selectedCategory: string | null;
  searchQuery: string;
  
  // Computed property
  get favoriteFeatures(): string[];
  
  toggleCompactMode: () => void;
  setSelectedCategory: (category: string | null) => void;
  
  // Favorite management
  isFavorite: (featureId: string) => boolean;
  addFavorite: (featureId: string) => void;
  removeFavorite: (featureId: string) => void;
  
  // Search
  setSearchQuery: (query: string) => void;
}

export const useSidebarPreferences = create(
  persist<SidebarPreferencesState>(
    (set, get) => ({
      isCompactMode: false,
      favorites: [],
      selectedCategory: null,
      searchQuery: '',
      
      // Computed property to get only the featureIds
      get favoriteFeatures() {
        return get().favorites.map(fav => fav.featureId);
      },
      
      toggleCompactMode: () => set(state => ({ isCompactMode: !state.isCompactMode })),
      setSelectedCategory: (category) => set({ selectedCategory: category }),
      
      isFavorite: (featureId) => {
        const { favorites } = get();
        return favorites.some(fav => fav.featureId === featureId);
      },
      
      addFavorite: (featureId) => {
        const { favorites } = get();
        // Don't add duplicate favorites
        if (!favorites.some(fav => fav.featureId === featureId)) {
          set({
            favorites: [...favorites, { featureId, pinnedAt: Date.now() }]
          });
        }
      },
      
      removeFavorite: (featureId) => {
        const { favorites } = get();
        set({
          favorites: favorites.filter(fav => fav.featureId !== featureId)
        });
      },
      
      setSearchQuery: (query) => set({ searchQuery: query }),
    }),
    {
      name: 'sidebar-preferences-storage',
    }
  )
);
